import {FC, useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import lRut from 'rut.js'
import {Redirect, useHistory} from 'react-router-dom'
import iconUserUp from '../../../../assets/img/icons/icon-user-up.svg'
import iconUser from '../../../../assets/img/icons/icon-user.svg'
import iconAdmiracion from '../../../../assets/img/icons/admiracion.svg'
import { Link } from 'react-router-dom';
import CONFIG from '../../../../../config'
import {EDocumentType} from '../../../../models'
import {Layout} from '../../../../containers'
import {
    Title,
    Text,
    Card,
    Button,
    Line,
    FormLabel,
    Input,
    FormLabelError,
    Select,
    Modal,
    FormMessageError,
    useModal,
    FormMessageSuccess,
    FormMessageAcceptReject,
    Radio
} from '../../../../components/UI'
import { storage} from '../../../../services'
import {useAuth, useUserDocumentsTypes} from '../../../../hooks'
import StepProgress from "../../../../components/UI/StepProgress/StepProgress";
import integrand from "../../../../assets/img/integrand.svg";
import integrandCheck from "../../../../assets/img/integrandCheck.svg";
import './AdminAddMemberFamilyGroupForm.scss';
import { formatRut } from 'react-rut-formatter'
import { User } from '../../interface/User'
import { adminFamilyGroupService } from '../../services/adminFamilyGroup.services'
import { useAdminFamilyGroupForm } from '../../hooks/useAdminFamilyGroupForm'

interface IFamilyGroupForm {
    firstName: string,
    documentTypeId: string,
    documentNumber: string,
    documentNumberStep2: string,
    relationshipTypeId: string,
    lastName: string,
    secondName: string,
    email: string,
    emilNotify: string
}

const defaultValues = {
    firstName: '',
    documentTypeId: '1',
    documentNumber: '',
    documentNumberStep2: '',
    relationshipTypeId: '',
    lastName: '',
    secondName: '',
    email: '',
    emilNotify: 'true'
}

export const AdminAddMemberFamilyGroupForm: FC<{userData: User}> = ({userData}) => {
    const {
        register,
        handleSubmit,
        formState: {errors, isDirty, isValid},
        watch,
        getValues,
        setValue,
        trigger,
        clearErrors,
        reset
    } = useForm<IFamilyGroupForm>({
        defaultValues
    })
    const history = useHistory()
    const [submited, setSubmited] = useState<boolean>(false)
    const [legalTextId, setLegalTextId] = useState<number | null>(null)
    const [docSel, setDocSel] = useState<any | null>(null)
    const docType = Number(watch('documentTypeId', defaultValues.documentTypeId))
    const familyGroup = useAdminFamilyGroupForm()
    const documentsTypes = useUserDocumentsTypes()
    const modal = useModal()
    const modalYounger = useModal()
    const steps: string[] = ["Buscar usuario", "Confirmar datos", "Enviar solicitud"];
    const [currentStep, setCurrentStep] = useState<number>(0);
    const [documentTypeStep1, setDocumentTypeStep1] = useState<string>('1');
    const [documentNumberStep1, setDocumentNumberStep1] = useState<string>('');
    const [documentTypeId, setDocumentTypeId] = useState<string>('');
    const [btnContinue, setBtnContinue] = useState<boolean>(false);
    const [loadingStep1, setLoadingStep1] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [patientExists, setPatientExists] = useState<boolean>(false);
    const [loadingStep2, setLoadingStep2] = useState<boolean>(false);
    const [isMinor, setIsMinor] = useState<boolean>(false);
    const auth = useAuth();
    const [requestId, setRequestId] = useState<number | null>(null);
    const [patientId, setPatientId] = useState<number | null>(null);

    const setFormData = (patient: any = {}) => {
        setValue('firstName', patient.first_name)
        setValue('lastName', patient.last_name)
        setValue('secondName', patient.second_name)
        setValue('email', patient.email)
        setValue('documentNumberStep2', patient.documentNumber)
        setDocumentTypeId(patient.documentTypeId)
    }

    const postForm = async (fData: any) => {
        setLoadingStep2(true);
        const postData = {...fData, patient_leader_id: userData.id}
        const resp = await adminFamilyGroupService.postFamilyGroup(postData)

        if (resp.status === 'Ok') {
            setCurrentStep(2);
            setPatientExists(true);
            setRequestId(resp?.data?.requestFamilyGroup?.id ?? null);
            setPatientId(resp?.data?.requestFamilyGroup?.family_patient_id ?? null);
        } else {
            modal.setMessage(resp.message)
            modal.setStatus('ERROR')
            modal.open()
        }
        setLoadingStep2(false);
        setSubmited(false)
    }

    const onFamilyGroupChange = async (event: any) => {
        const {target: {name, value}} = event
        setValue(name, value)
        await trigger(name)
    }

    const onModalYoungerAccept = () => {
        modalYounger.close()
    }

    const onModalYoungerReject = () => {
        setLegalTextId(null)
        history.push(CONFIG.ROUTES.DASHBOARD.FAMILYGROUP.HOME)
    }

    const onSubmit = (fData: IFamilyGroupForm) => {
        const {
            documentNumber,
            relationshipTypeId,
            emilNotify,
            firstName,
            lastName,
            secondName,
            email
        } = fData

        setSubmited(true)
        const currentUser = storage.get('currentUser');
        let data: any = {
            family_document_type: documentTypeId,
            family_document_number: (parseInt(documentTypeId) === EDocumentType.rut ? lRut.clean(documentNumber) : documentNumber),
            type_relationship_id: Number(relationshipTypeId),
            notify_mail: !!emilNotify,
            first_name: firstName,
            last_name: lastName,
            second_name: secondName,
            email: email,
            user: currentUser.info.first_name + ' ' + currentUser.info.last_name ,
        }
        if (legalTextId) data.legal_text_id = legalTextId
        postForm(data)
    }

    const handleSearchIntegrand = async () => {
        setLoadingStep1(true);

        if(userData.document_number.toLowerCase().replace(/[-\s]/g,'') === documentNumberStep1.toLowerCase().replace(/[-\s]/g,'')) {
            setErrorMessage(`El documento ingresado corresponde al usuario ${userData.first_name} ${userData.last_name}`);
            setBtnContinue(false);
            setLoadingStep1(false);
            return false;
        }

        if (documentNumberStep1 === '' || documentTypeStep1 === '') {
            setBtnContinue(false);
            setLoadingStep1(false);
            return false
        }

        const resp = await adminFamilyGroupService.getFamily(documentTypeStep1, documentNumberStep1)

        setLoadingStep1(false);
        if (resp.status === 'Ok') {
            const {patient} = resp.data
            patient.documentNumber = getValues('documentNumber');
            patient.documentTypeId = documentTypeStep1;
            setFormData(patient);
            setPatientExists(true);
            if (patient?.is_minor) {
                const resp: any = await adminFamilyGroupService.getFamilyLegalText()
                modalYounger.setMessage(resp?.data.text)
                modalYounger.open()
                setLegalTextId(resp?.data.id)
            }
            setCurrentStep(1);
        } else {
            setErrorMessage('El usuario no está registrado en Mi Portal INDISA. Para agregarlo al grupo familiar, primero debe crear una cuenta.');
            setBtnContinue(false);
            setPatientExists(false);
            setFormData({});
        }
    }

    const onDocumentTypeStep1 = (event: any) => {
        const {value} = event.target;
        setDocumentTypeStep1(value);
        setDocumentNumberStep1('');
        setBtnContinue(false);
        setErrorMessage('');
        setValue('documentNumber', '');
        clearErrors('documentNumber');
    }

    const onDocumentNumberChangeStep1 = async (event: any) => {
        const docNumberName = 'documentNumber';
        let documentNumber = getValues(docNumberName);

        if (documentTypeStep1 === '1' && documentNumber.length >= 3) {
            documentNumber = formatRut(documentNumber);
            setValue(docNumberName, documentNumber, { shouldValidate: true });
        }

        const docNumberResp = await trigger(docNumberName);
        setErrorMessage('');

        if (docNumberResp && (event.code !== 'KeyC' && event.key !== 'Control')) {
            const docTypeName = 'documentTypeId';
            const documentTypeId = getValues(docTypeName);

            if (docSel?.documentTypeId !== documentTypeId && docSel?.documentNumber !== documentNumber) {
                setBtnContinue(true);
                setDocumentNumberStep1(documentNumber);
            } else {
                setBtnContinue(false);
            }
        }
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
        if (event.key === 'Enter') {
            const activeElement = document.activeElement as HTMLElement;

            if (activeElement && activeElement.id === 'backButton') {
                return;
            }

            event.preventDefault();

            if (activeElement && activeElement.id !== 'backButton' && btnContinue) {
                handleSearchIntegrand();
            }
        }
    };

    useEffect(() => {
      const userInfo = auth.getInfo();
      
      const calculateIsMinor = (birthDate: string): boolean => {
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
          age--;
        }
        
        return age < 18;
      };
  
      const isMinorByFlag = userInfo?.is_a_minor || false;
      const isMinorByAge = userInfo?.date_birth ? calculateIsMinor(userInfo.date_birth) : false;
      
      setIsMinor(isMinorByFlag || isMinorByAge);
    }, []);


    if (isMinor) {
      return <Redirect to={CONFIG.ROUTES.DASHBOARD.FAMILYGROUP.HOME} />;
    }

    return (
      <>
        <Card showOnly="lg" className="pt-50 pb-30 lg:pb-50 lg:mt-30 px-40">


            <StepProgress steps={steps} currentStep={currentStep}/>

            {currentStep == 0 && <form onKeyDown={handleKeyDown}>
              <img src={integrand} alt="Grupo familiar" width={52} height={52} className="mx-auto d-block"/>
              <h3 className='fz-20 text-center mt-20'>Agregar integrante</h3>
              <div className='d-block mx-auto text-center wmax-518 mt-10'>Para continuar, introduce los datos de
                la persona que deseas agregar al Grupo Familiar de {userData.first_name} {userData.last_name}.
              </div>
                { errorMessage && (<div className='message-error'>{errorMessage}</div>) }
              <div className='my-20 wmax-518 mx-auto'>
                <div className='d-flex'>
                  <fieldset className='mr-10'>
                    <Radio
                      id="select_rut"
                      name="select_integrant"
                      value="1"
                      tabIndex={1}
                      defaultChecked={true}
                      onChange={onDocumentTypeStep1}
                    />
                    <FormLabel htmlFor="select_rut">Rut</FormLabel>
                  </fieldset>

                  <fieldset>
                    <Radio
                      id="select_passport"
                      name="select_integrant"
                      value="2"
                      tabIndex={2}
                      onChange={onDocumentTypeStep1}
                    />
                    <FormLabel htmlFor="select_passport">Pasaporte</FormLabel>
                  </fieldset>

                </div>

                <fieldset className='mt-20'>
                    {documentTypeStep1 === '1' &&
                      <Input
                          {...register('documentNumber', {
                              required: `Digita ${CONFIG.AUTH.LABEL.RUT}`,
                              pattern: {
                                  value: CONFIG.FORM.PATTERN.RUT.EXP,
                                  message: `Digita ${CONFIG.AUTH.LABEL.RUT} válido`
                              },
                              validate: value => lRut.validate(value) || `Digita ${CONFIG.AUTH.LABEL.RUT} válido`
                          })}
                          id="documentNumber"
                          className='input_text'
                          placeholder={CONFIG.AUTH.PLACEHOLDER.RUT}
                          fullWidth
                          tabIndex={3}
                          error={!!errors.documentNumber}
                          maxLength={CONFIG.FORM.PATTERN.RUT.MAXLENGHT}
                          onKeyUp={onDocumentNumberChangeStep1}
                          name="documentNumber"
                      />
                    }

                    {documentTypeStep1 === '2' &&
                      <Input
                        id="documentNumber"
                        {...register('documentNumber', {
                            required: `Digita ${CONFIG.AUTH.LABEL.PASSPORT}`,
                            pattern: {
                                value: CONFIG.FORM.PATTERN.PASSPORT.EXP,
                                message: `Digita ${CONFIG.AUTH.LABEL.PASSPORT} válido`
                            },
                            validate: value => true
                        })}
                        name="documentNumber"
                        className='input_text'
                        placeholder={CONFIG.AUTH.PLACEHOLDER.PASSPORT}
                        fullWidth
                        tabIndex={3}
                        onKeyUp={onDocumentNumberChangeStep1}
                        error={!!errors.documentNumber}
                      />
                    }
                    {errors.documentNumber && <FormLabelError>{errors.documentNumber?.message}</FormLabelError>}
                </fieldset>

                <div className='d-flex my-20 mx-auto wmax-518 justify-content-center'>

                  <Link to={`${CONFIG.ROUTES.ADMIN.FAMILY.HOME}/${userData.id}`} className='w-full wmax-127 fw-bold text-primary mx-10 btn-custom bd brd-8 bd-primary' tabIndex={4} id="backButton">
                    <i className='icon-arrow-left'></i>
                    VOLVER
                  </Link>

                    {loadingStep1 && (<div className={'spinner'}></div>)}

                    {!loadingStep1 && <Button type="button" disabled={!btnContinue} className='w-full mx-10 btn-custom wmax-127' size="lg"
                          color='primary'
                          onClick={handleSearchIntegrand}
                          tabIndex={5} 
                          data-ga-event-name="button_continue_to_step_two"
                          >   
                    CONTINUAR
                  </Button> }


                </div>
              </div>
              <div className='bd bd-1 brd-8 p-25'>
                <div className='fw-bold mb-30'>Al agregar personas a un Grupo familiar debes considerar lo
                  siguiente:
                </div>
                <div className='md:d-flex fz-13 justify-content-between'>
                  <div className='d-flex w-full md:wmax-280 mb-5'>
                    <img src={iconUser} alt='user' height="20" className='mr-15'/>
                    <span>Sólo podrás incorporar a personas registradas en Mi Portal INDISA.</span>
                  </div>
                  <div className='d-flex w-full md:wmax-280 mb-5 mr-5'>
                    <img src={iconUserUp} alt='user' height="20" className='mr-15'/>
                    <span>A personas mayores de edad solamente podrás reservar horas.</span>
                  </div>
                  <div className='d-flex w-full md:wmax-280 mb-5'>
                    <img src={iconUserUp} alt='user' height="20" className='mr-15'/>
                    <span>A hijo(a) menor de edad podrás reservar horas y ver historial médico.</span>
                  </div>
                </div>
              </div>
            </form>
            }

            {currentStep == 1 && <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>

                  <div className="row">

                    <h3 className='fz-20 text-center mt-20 w-full'>Formulario de solicitud de nuevo integrante</h3>
                    <div className='d-block mx-auto text-center wmax-942 mt-10 mb-20'>
                      {patientExists 
                        ? `Verifica los datos encontrados y selecciona el tipo de relación para añadir al usuario al grupo familiar de ${userData.first_name} ${userData.last_name}.` 
                        : 'Debido a que el usuario no se encuentra registrado en Mi Portal INDISA, primero debe crear una cuenta.'}
                    </div>

                    <fieldset className="col-12 lg:col-6 mt-30">
                      <FormLabel htmlFor="firstName">Nombre</FormLabel>
                      <Input
                          {...register('firstName')}
                          id="firstName"
                          name="firstName"
                          placeholder="Nombre"
                          fullWidth
                          readOnly = {patientExists}
                          tabIndex={1}
                          className="mt-5 input_text"
                      />
                    </fieldset>

                    <fieldset className="col-12 lg:col-6 mt-30">
                      <FormLabel htmlFor="lastName">Primer apellido</FormLabel>
                      <Input
                          {...register('lastName')}
                          id="lastName"
                          name="lastName"
                          placeholder="Apellido"
                          fullWidth
                          readOnly = {patientExists}
                          tabIndex={2}
                          className="mt-5 input_text"
                      />
                    </fieldset>

                    <fieldset className="col-12 lg:col-6 mt-30">
                      <FormLabel htmlFor="secondName">Segundo apellido</FormLabel>
                      <Input
                          {...register('secondName')}
                          id="secondName"
                          name="secondName"
                          placeholder="Apellido"
                          fullWidth
                          readOnly = {patientExists}
                          tabIndex={3}
                          className="mt-5 input_text"
                      />
                    </fieldset>

                    <fieldset className="col-12 lg:col-6 mt-30">
                      <FormLabel htmlFor="email">Correo electrónico </FormLabel>
                      <Input
                          {...register('email')}
                          id="email"
                          name="email"
                          placeholder="Correo electrónico "
                          fullWidth
                          readOnly = {patientExists}
                          tabIndex={4}
                          className="mt-5 input_text"
                      />
                    </fieldset>

                    <fieldset className="col-12 lg:col-6 mt-30">
                      <FormLabel htmlFor="secondName" required>Tipo de relación</FormLabel>
                      <Select
                          {...register('relationshipTypeId', {required: 'Selecciona Tipo de relación'})}
                          id="relationshipTypeId"
                          name="relationshipTypeId"
                          defaultValue=""
                          tabIndex={5}
                          fullWidth
                          required
                          loading={familyGroup.data === null}
                          error={!!errors.relationshipTypeId}
                          className="mt-5 select_sty1"
                          onChange={onFamilyGroupChange}
                      >
                        <option value="" disabled>Tipo de relación</option>
                          {familyGroup.data && familyGroup.data.length > 0 &&
                              familyGroup.data.map((it: any, i: number) => <option key={i}
                                                                                    value={it.id}>{it.name}</option>)
                          }
                      </Select>
                        {errors.relationshipTypeId &&
                          <FormLabelError>{errors.relationshipTypeId?.message}</FormLabelError>}
                    </fieldset>

                    <div className="col-12 lg:col-6 mt-30">
                      <div className='d-flex'>
                        <fieldset className='mr-10'>
                          <Radio
                            id="select_rut_step2"
                            name="select_document_step2"
                            value="1"
                            tabIndex={6}
                            disabled={true}
                            defaultChecked={documentTypeId == '1'}
                          />
                          <FormLabel htmlFor="select_rut_step2">Rut</FormLabel>
                        </fieldset>
                        <fieldset>
                          <Radio
                            id="select_passport_step2"
                            name="select_document_step2"
                            value="2"
                            tabIndex={7}
                            disabled={true}
                            defaultChecked={documentTypeId == '2'}
                          />
                          <FormLabel htmlFor="select_passport_step2">Pasaporte</FormLabel>
                        </fieldset>
                      </div>
                      <fieldset className='mt-6'>
                          {documentTypeStep1 === '1' &&
                            <Input
                                {...register('documentNumberStep2')}
                                id="documentNumber_step2"
                                className='input_text'
                                fullWidth
                                tabIndex={8}
                                readOnly
                                name="documentNumber_step2"
                            />
                          }

                          {documentTypeStep1 === '2' &&
                            <Input
                              {...register('documentNumberStep2')}
                              id="documentNumber_step2"
                              name="documentNumber_step2"
                              className='input_text'
                              fullWidth
                              readOnly
                              tabIndex={9}
                            />
                          }
                      </fieldset>
                    </div>
                  </div>


                  <div className="text-center lg:pr-70 mt-50">
                    <Button type="button" className='mx-10 btn-custom' size="lg" tabIndex={10} onClick={
                        () => {
                            setErrorMessage('');
                            setCurrentStep(0);
                            setLoadingStep1(false);
                            setDocumentTypeId('1');
                            setDocumentTypeStep1('1');
                            setDocumentNumberStep1('');
                            setValue('documentNumber', '');
                            clearErrors('documentNumber');
                            setPatientExists(false);
                            setBtnContinue(false);
                        }}>
                      <i className='icon-arrow-left'></i>
                      VOLVER
                    </Button>

                      {loadingStep2 && (<div className="wrapper-laoding"><div className={'spinner'}></div></div>)}

                      {!loadingStep2 && (<Button type="submit" color='primary' className='btn--primary btn--lg   mx-10 btn-custom' size="md"
                            disabled={(!isDirty || !isValid) || submited} tabIndex={11} data-ga-event-name="button_send_request_family_group">
                      ENVIAR SOLICITUD
                    </Button>) }
                  </div>

                </form>
            }

            {currentStep == 2 &&
              <div>
                <img src={integrandCheck} alt="Grupo familiar" width={52} height={52} className="mx-auto d-block"/>
                <h3 className='fz-20 text-center mt-20'>Solicitud enviada</h3>
                <div className='d-block mx-auto text-center wmax-518 mt-10'>La solicitud para agregar a <span className='fw-bold'>{ getValues('firstName') + ' ' + getValues('lastName')}</span> al grupo familiar de {userData.first_name} {userData.last_name}, se ha enviado con éxito.
                </div>
                <div className='mx-auto wmax-455 bg-note fz-14 my-20 p-20 d-flex'>

                  <img src={iconAdmiracion} alt='' width={20} height={20} className='mr-10'/>
                  <div className='d-block'>
                      <div className='fw-bold fz-13 note-title mb-5'>
                        Nota importante
                      </div>
                      Es necesario la aprobación del usuario a través de su cuenta de "Mi Portal INDISA" o bien, puedes aprobar la solicitud AHORA como Administrador.
                  </div>

                </div>
                <div className='d-flex wmax-518 mx-auto text-center justify-content-center'>
                  
                  <Link  to={`${CONFIG.ROUTES.ADMIN.FAMILY.HOME}/${patientId ? patientId : ''}?tab=requests&request_id=${requestId ? requestId : ''}`}   className='btn--primary btn--lg mx-10 btn-custom py-10 fw-bold'>
                    Aprobar solicitud ahora
                  </Link>

                </div>
              </div>
            }

        </Card>

        <Modal show={modal.show} maxWidth="345px" onClose={() => modal.close()}>
            {modal.status === 'SUCCESS' &&
              <FormMessageSuccess
                className="p-50"
                title="¡La solicitud ha sido enviada con éxito!"
                message={modal.message}
              />
            }
            {modal.status === 'ERROR' &&
              <FormMessageError
                className="p-50"
                message={modal.message}
                onClick={() => modal.close()}
              />
            }
        </Modal>

        <Modal
            show={modalYounger.show}
            maxWidth="680px"
            buttonCloseHide={true}
        >
            <FormMessageAcceptReject
                className="p-50"
                onAcceptClick={onModalYoungerAccept}
                onRejectClick={onModalYoungerReject}
            >
                <div dangerouslySetInnerHTML={{__html: modalYounger.message}}/>
            </FormMessageAcceptReject>
        </Modal>
      </>
    )
}
